import React from 'react'
import { StyleSheet } from 'react-native'
import {
  Iffy,
  DNABox,
  DNAText,
  DNADivider,
} from '@alucio/lux-ui'
import { DeviceMode, useAppSettings } from 'src/state/context/AppSettings'
import HubsTable from 'src/components/Hubs/HubsTable'
import DNAEmpty, { EmptyVariant } from 'src/components/DNA/Empty/DNAEmpty'
import HubsStateProvider, { useHubsState, HubVariant } from 'src/state/context/Hubs/HubsStateProvider'
import { useParams } from 'react-router'
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'
import EditHubWrapper from 'src/screens/Hubs/EditHub/EditHub'
import { HubType } from '@alucio/aws-beacon-amplify/src/models'
import HubsTemplateHeader from 'src/components/Hubs/HubsTemplateHeader'

const S = StyleSheet.create({
  tabletContainer: {
    backgroundColor: colors['color-text-white'],
    overflow:'scroll',
  }
})

export const DNAHubList: React.FC = () => {
  const { hubsORM:allHubsORM, handleCreateHubs, handleCreateTemplateInstance } = useHubsState()
  const hubsORM = allHubsORM.filter(hub => hub.model.hubType !== HubType.TEMPLATE)

  return (
    <DNABox
      alignX="center"
      fill
    >
        <DNABox
          fill
          alignX="center"
        >
          <DNABox
            fill
            spacing="md"
            appearance="col"
            testID="page-container"
            childFill={1}
          >
            {/* Header */}
            <HubsTemplateHeader
                title="Hubs"
                description="Create hubs to share content and track your audience activity"
              />
            <DNABox fill>
            {
              hubsORM.length
                ? <HubsTable />
                : <DNAEmpty emptyVariant={EmptyVariant.HubsEmpty} />
            }
          </DNABox>
        </DNABox>
      </DNABox>
    </DNABox>
  )
}

const DNAHubListWrapper: React.FC = () => {
  const { hubId } = useParams<{ hubId: string }>()

  return (
    <HubsStateProvider hubId={hubId} variant={HubVariant.STANDALONE}>
      <DNAHubList />
      <EditHubWrapper />
    </HubsStateProvider>
  )
}

export default DNAHubListWrapper
